import { LinearProgress, linearProgressClasses, LinearProgressProps, styled } from "@mui/material";

interface ProgressBarProps extends LinearProgressProps {
}

function ProgressBar({ ...props }: ProgressBarProps) {
  const CustomLinear = styled(LinearProgress)(({ theme }) => ({
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: "#CDEBDC",
      ...theme.applyStyles('dark', {
        backgroundColor: "#CDEBDC",
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: '#009C4E',
      ...theme.applyStyles('dark', {
        backgroundColor: '#009C4E',
      }),
    }
  }))
  return (
    <CustomLinear {...props} />
  );
}

export default ProgressBar;